import APIClient from '@/shared/http/clients/api'

const APIPci = process.env.APIBaseURLPci
const resourceName = 'PdrLayout'

const GetAll = (data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}`, data, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APIPci}/${resourceName}`, data, config)
const Delete = (pdrLayoutID, data = {}, config = {}) => APIClient.delete(`${APIPci}/${resourceName}/${pdrLayoutID}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APIPci}/${resourceName}`, data, config)

export default {
  GetAll,
  Create,
  Delete,
  Update
}



// WEBPACK FOOTER //
// ./src/shared/http/repositories/pci/layoutpdr.js